import classnames from 'classnames';
import * as React from 'react';
import '../spinner/index.js';
import { overlay } from './spinner_overlay.css.js';
import { Spinner } from '../spinner/spinner.js';

const SpinnerOverlay = React.memo(function SpinnerOverlay({ className }) {
    return (React.createElement("div", { className: classnames(overlay, className) },
        React.createElement(Spinner, { size: "large" })));
});

export { SpinnerOverlay };
